import React from 'react';
import { SlidersHorizontal, XIcon } from 'lucide-react';
import { translate } from '@/services/TranslationService';
import { NovovilleButton, Typography } from '@/components/novoville';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import NOVOLoader from '@/shared/components/NOVOLoader';
import FiltersComponent from '../FiltersComponent';
import MapBoxContainer from '../MyCityMapContainer';

const MyCityMobileLayout = ({
  mapProps,
  filtersProps,
  markersLoaded,
  loaderStyles,
  activeFilters,
  resultsCount,
}) => (
  <div className="flex sm:p-[2.5rem] sm:pt-[2rem] sm:h-fit max-h-[calc(100vh-5rem)] sm:pb-0 p-0">
    <div className="flex flex-col bg-white w-full h-[calc(100vh-5rem)]">
      {markersLoaded ? (
        <>
          <Drawer className="z-[100]">
            <DrawerTrigger>
              <NovovilleButton
                variant="primary"
                className="absolute bottom-[2.5rem] right-[50%] translate-x-[50%] z-[10] w-fit"
              >
                <SlidersHorizontal className="w-[1.25rem] h-[1.25rem] text-gray-500" />
                <Typography variant="semibold_16">
                  {translate('Filters')}
                </Typography>
                {activeFilters.length > 0 && (
                  <div className="bg-gray-800 rounded-full w-[1rem] h-[1rem] flex items-center justify-center">
                    <span className="text-[.625rem] font-medium text-white">
                      {activeFilters.length}
                    </span>
                  </div>
                )}
              </NovovilleButton>
            </DrawerTrigger>
            <DrawerContent
              className="flex flex-col max-h-[calc(100vh-5rem)]"
              showHandle={false}
            >
              <DrawerHeader className="border-b border-gray-200">
                <DrawerTitle className="flex items-center justify-between">
                  <Typography
                    variant="semibold_16"
                    className="flex-grow text-center"
                  >
                    {translate('Filters')}
                  </Typography>
                  <DrawerClose>
                    <XIcon className="w-[1.25rem] h-[1.25rem] cursor-pointer text-[#000] ml-auto" />
                  </DrawerClose>
                </DrawerTitle>
              </DrawerHeader>
              <DrawerDescription className="flex-grow overflow-auto">
                <FiltersComponent isMobile {...filtersProps} />
              </DrawerDescription>
              <DrawerFooter className="flex flex-row justify-between border-t border-gray-200">
                {activeFilters.length > 0 && (
                  <NovovilleButton
                    variant="secondary"
                    className="w-1/2"
                    onClick={filtersProps.clearFilters}
                  >
                    {translate('ClearFilters')}
                  </NovovilleButton>
                )}
                <DrawerClose
                  className={`${activeFilters.length > 0 ? 'w-1/2' : 'w-full'}`}
                >
                  <NovovilleButton variant="primary" className="w-full">
                    {`${resultsCount} ${translate('Results')}`}
                  </NovovilleButton>
                </DrawerClose>
              </DrawerFooter>
            </DrawerContent>
          </Drawer>
          <MapBoxContainer {...mapProps} />
        </>
      ) : (
        <NOVOLoader style={loaderStyles} />
      )}
    </div>
  </div>
);

export default MyCityMobileLayout;
